module.exports = __webpack_public_path__ + "img/san-jose-beach-2.d6f2f8c9.jpg";